import { graphql, useStaticQuery } from 'gatsby';
import { CityNode, CityWithNumberOfLocations } from 'lib/types';
import * as React from 'react';

interface LocationWithCity {
    city: null | CityNode;
}

type CitiesWithNumberOfLocationsQuery = {
    allLocation: {
        nodes: ReadonlyArray<LocationWithCity>;
    };
};

export const query = graphql`
    query CitiesWithNumberOfLocationsQuery {
        allLocation {
            nodes {
                city {
                    cityId
                    slug
                    label
                    sortOrder
                }
            }
        }
    }
`;

export default function useCitiesWithNumberOfLocations(): ReadonlyArray<CityWithNumberOfLocations> {
    const { allLocation } =
        useStaticQuery<CitiesWithNumberOfLocationsQuery>(query);

    return React.useMemo<ReadonlyArray<CityWithNumberOfLocations>>(() => {
        const cities = Object.values(
            allLocation.nodes.reduce<Record<string, CityWithNumberOfLocations>>(
                (aggregator, { city }) => {
                    if (city) {
                        const { cityId } = city;

                        const numberOfLocations =
                            (aggregator[cityId]?.numberOfLocations ?? 0) + 1;

                        return {
                            ...aggregator,
                            [cityId]: {
                                ...city,
                                numberOfLocations,
                            },
                        };
                    }

                    return aggregator;
                },
                {},
            ),
        );

        return cities.sort((a, b) => a.label.localeCompare(b.label));
    }, [allLocation]);
}
